import { render, staticRenderFns } from "./MainWholesalers.vue?vue&type=template&id=0a66c77b&scoped=true&"
import script from "./MainWholesalers.vue?vue&type=script&lang=js&"
export * from "./MainWholesalers.vue?vue&type=script&lang=js&"
import style0 from "./MainWholesalers.vue?vue&type=style&index=0&id=0a66c77b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a66c77b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
